export default __webpack_public_path__ + "static/media/card-bottom1.a8a2ea06.webp";